import { LuShoppingCart } from "react-icons/lu";
import { calculate_total_price } from "./Calculate_price";
import { useWatch } from "react-hook-form";
import { formConfig } from "../form/formConfig";
import { berekenBreedte } from "../configurator/Helpers";

export const TotalPrice = ({orders, openBasket}) => {

  const default_frame_code = 'OAK'
  
  const { WIDTH, HEIGHT } = useWatch({ name: "DIMENSION" }) || ({WIDTH:500, HEIGHT:190})
  const {gecorrigeerdeBreedte, aantal_planken} = berekenBreedte(WIDTH);


  const frameColor = useWatch({ name: "FRAME_COLOR" }) || default_frame_code; // Voor de framekleur
  const option_color = formConfig
  .find((x) => x.name == "FRAME_COLOR")
  .options.find((x) => x.code == frameColor);


  const total_price = gecorrigeerdeBreedte * HEIGHT / 202 * option_color.priceFactor;
  const formattedPrice = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0
  }).format(total_price);
  

  return (
    <>

<div className="p-4">
<div className="h-auto bg-red flex justify-start mb-2">
    <div className="flex items-center h-5">

        <input
                  type="checkbox"
                  id="voorwaarden"
                  className="w-4 h-4 border border-white rounded bg-white focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                />
                </div>
                <label htmlFor="voorwaarden" className="ms-2 text-sm font-medium text-white ">
                  Ik ben akkoord met de <a href="#" className="text-white hover:underline underline dark:text-blue-500">voorwaarden</a>
                </label>
                </div>

      <div className="flex justify-between items-start">
        <div className="flex flex-col justify-between gap-0">
          <span className="text-3xl md:text-4xl font-extrabold text-white">€ {formattedPrice}</span>
          <span className="text-white text-sm font-medium">Incl 21% BTW</span>
        </div>
        <div className="flex gap-2">

          <button
            type="button"
            className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 border-white border-white border border-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Bestellen
          </button>
        </div>
      </div>
      </div>
    </>
  );
};
